import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class CustomIcon extends Component {
  render() {
    const { size, name, color, onClick, style, classes, id } = this.props;
    let sizeFixed = size;

    if (!size) sizeFixed = 'inherit';
    let styles = { fontSize: sizeFixed, display: 'inline-flex' };

    if (color) styles.color = color;

    if (style) {
      styles = {
        ...styles,
        ...style
      };
    }
    return <i id={id} onClick={onClick} className={`custom-icons-${name} ${classes}`} style={styles} />;
  }
}

CustomIcon.propTypes = {
  size: PropTypes.number.isRequired,
  name: PropTypes.string,
  color: PropTypes.string,
  classes: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
  id: PropTypes.string
};
